import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class Funcionalidade implements Construtor<Funcionalidade> {

  public idFuncionalidade: number;
  public nomeFuncionalidade: string;
  public selecionado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {

      if (object instanceof Funcionalidade) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdFuncionalidade(): number {
    return this.idFuncionalidade;
  }

  set IdFuncionalidade(idFuncionalidade: any) {
    this.idFuncionalidade = idFuncionalidade;
  }

  get obterNomeFuncionalidade(): string {
    return this.nomeFuncionalidade.slice(0);
  }

  set NomeFuncionalidade(nomeFuncionalidade: any) {
    this.nomeFuncionalidade = StringValidacao.copiarStringValida(nomeFuncionalidade);
  }

  copyObject(funcionalidade: Funcionalidade): void {

    this.idFuncionalidade = funcionalidade.obterIdFuncionalidade;
    this.nomeFuncionalidade = funcionalidade.obterNomeFuncionalidade;
  }

  parseFromJson(funcionalidade: any): void {

    this.IdFuncionalidade = funcionalidade.idFuncionalidade;
    this.NomeFuncionalidade = funcionalidade.nomeFuncionalidade;

  }

  modeloCompleto(): boolean {
    return this.nomeFuncionalidade !== undefined;
  }

  getNewInstance(object?: any): Funcionalidade {
    return new Funcionalidade(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/funcionalidade.ts